import { useEffect } from "preact/hooks";

import { Browser, getBrowser } from "../../foundation/utils/ua-utils";

interface ReturnType {
    cleanUp: () => void;
}

/*
    This hook adds a temporary "readOnly=true" attribute to given type able element,
    then removes immediately when it's activated. This prevents safari auto fill engine's heuristic
    while detecting text correction places.
*/
export function applyReadOnlyUntilFocusToDisableAutofillInSafari(input: HTMLInputElement): ReturnType | undefined {
    const isSafari = getBrowser() === Browser.Safari;

    if (!input || !isSafari) {
        return;
    }

    const isAlreadyReadOnly = input.readOnly;

    if (!isAlreadyReadOnly) {
        input.readOnly = true;
    }

    const handleInputUnlock = (e: Event) => {
        if (!isAlreadyReadOnly && input.readOnly) {
            e.preventDefault(); // Prevent native focus on readonly field
            input.readOnly = false;
            input.focus(); // Manually focus after removing readonly
        }
    };

    input.addEventListener("mousedown", handleInputUnlock, true);

    return {
        cleanUp: () => {
            input.removeEventListener("mousedown", handleInputUnlock, true);
        }
    };
}

export const useDisableAutoFillSafariBrowsers = (input: HTMLInputElement) => {
    useEffect(() => {
        if (!input) {
            return;
        }

        const result = applyReadOnlyUntilFocusToDisableAutofillInSafari(input);

        return result?.cleanUp;
    }, [input]);
};
